import React, { useMemo } from 'react';
import { numWordForm } from '@frontend/jetlend-core/src/utils/langUtils';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { CourseComplexityDictionary } from '@app/models/features/course';
import Image from '@app/components/Image/Image';
import styles from './CourseHeaderBadge.module.scss';
import complexityIcon from '@app/icons/academy/complexity-icon.svg';
import clockIcon from '@app/icons/academy/clock-icon.svg';
import lessonsIcon from '@app/icons/academy/lessons-amount-icon.svg';
import achievementIcon from '@app/icons/academy/achievement-icon-2.svg';
import questionsIcon from '@app/icons/academy/questions--icon.svg';

type BadgeTypes = 'complexity' | 'estimated_time' | 'lessons_amount' | 'reward' | 'questions_amount' | 'achievement';

const ICON_CONFIG: Record<BadgeTypes, string> = {
    complexity: complexityIcon,
    estimated_time: clockIcon,
    lessons_amount: lessonsIcon,
    questions_amount: questionsIcon,
    reward: achievementIcon,
    achievement: achievementIcon,
};

interface IProps {
    /**
     * тип баджа
     */
    type: BadgeTypes;
    /**
     * текст/значение баджа
     */
    value: string|number;
    /**
     * размер баджа
     */
    size?: 'default'|'small';
}

/**
 * Компонент отрисовывает бадж в хедере
 *
 * Выводит:
 * - Сложность
 * - Ожидаемое время
 * - Количество блоков
 */
const CourseHeaderBadge = (props: IProps) => {
    const {
        type,
        value,
        size = 'default',
    } = props;

    const text = useMemo(() => {
        switch (type) {
        case 'complexity': {
            return CourseComplexityDictionary[value];
        }
        case 'estimated_time': {
            return numWordForm(value, 'minutes');
        }
        case 'lessons_amount': {
            return numWordForm(value, 'tasks');
        }
        case 'achievement': {
            return `+${numWordForm(value, 'gifts')}`;
        }
        case 'questions_amount': {
            return numWordForm(value, 'questions');
        }
        }
    }, [type, value]);

    const badgeClassName = buildClassNames(styles, [
        'container',
        `container--${size}`,
    ]);

    return (
        <div className={badgeClassName}>
            <div className={styles['text']}>
                {text}
            </div>
            <div className={styles['icon']}>
                <Image src={ICON_CONFIG[type]} fill alt="" />
            </div>
        </div>
    );
};

export default CourseHeaderBadge;
